import { Type } from '@angular/core';
import { ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy} from '@angular/router';
import {EntityDataLayoutComponent} from "@layout/layouts/entity-data/entity-data-layout.component";

/**
 * Route reuse means not destroying and creating the same component when changing route.
 */
export class MojoRouteReuseStrategy
  implements RouteReuseStrategy {

    prevRoute: ActivatedRouteSnapshot;
    prevHandle: DetachedRouteHandle | null;

    static permittedReuseTypes: Type<any>[] = [
      EntityDataLayoutComponent
    ];

    shouldDetach(route: ActivatedRouteSnapshot): boolean {
      return route.data.reuseRoute === true;
    }

    store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle | null): void {
      this.prevRoute = route;
      this.prevHandle = handle;
    }

    shouldAttach(route: ActivatedRouteSnapshot): boolean {
      return route.data.reuseRoute === true && !!this.prevRoute && !!this.prevHandle;
    }

    retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
      return this.prevHandle;
    }

    shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
      if (!future.data.reuseRoute) {
        this.prevRoute = undefined;
        this.prevHandle = undefined;
      }
      return this.isReuseEnabled(future, curr);
    }

    private isReuseEnabled(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
      return future.data.reuseRoute === true
        && curr.data.reuseRoute === true
        && future.data.component === curr.data.component
        && MojoRouteReuseStrategy.permittedReuseTypes.includes(future.data.component)
        && MojoRouteReuseStrategy.permittedReuseTypes.includes(curr.data.component);
    }
}
